import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import Collapse from "react-bootstrap/Collapse";
import Select, { components } from "react-select";
import AssetVehicleModal from './AssetVehicleModal';
import AssestVechileServices from "../../../services/AssestVechileServices";
import UserServices from "../../../services/UserServices";
import Swal from "sweetalert2";

const AssetVehicleList = () => {

    const [open, setOpen] = useState(true);
    const [open2, setOpen2] = useState(true);

    const [searchQuery, setSearchQuery] = useState("");
    const [sort, setSort] = useState(10);
    const [showModal, setShowModal] = useState(false);
    const [editRowId, setEditRowId] = useState(null);
    const [operatorOptions, setOperatorOptions] = useState([]);
    const [selectedOperators, setSelectedOperators] = useState([]);
    const [hoverUsers, setHoverUsers] = useState([]);
    const [showHover, setShowHover] = useState(false);
    const [hoverPosition, setHoverPosition] = useState({ x: 0, y: 0 });
    const [editNumberRowId, setEditNumberRowId] = useState(null);
    const [editValues, setEditValues] = useState({
        average: "",
        capacity: ""
    });

    const activePag = useRef(0);

    // ✅ add this
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);

    const options = [
        { value: 5, label: "5" },
        { value: 10, label: "10" },
        { value: 20, label: "20" },
        { value: 50, label: "50" },
    ];

    const fetchAssetVehicles = async () => {
        try {
            setLoading(true);

            const res = await AssestVechileServices.getAllAssetVehicles();

            // adjust based on your API response structure
            const result = res?.data || [];

            setData(result);

        } catch (err) {
            console.error("Error fetching asset vehicles:", err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchAssetVehicles();
    }, []);

    const filteredData = data.filter((item) => {
        const query = searchQuery.toLowerCase();

        return (
            item?.asset?.masterItem?.description?.toLowerCase().includes(query) || // Vehicle Name
            item?.asset?.store?.name?.toLowerCase().includes(query) ||            // Store
            item?.asset?.equipmentNo?.toLowerCase().includes(query) ||           // Equipment No
            item?.vehicleType?.toLowerCase().includes(query) ||                  // Type
            item?.operators?.some(op =>
                op?.name?.toLowerCase().includes(query)                          // Operators
            )
        );
    });

    useEffect(() => {
        const fetchUsers = async () => {
            try {
                const res = await UserServices.getAllUser();

                const users = res?.data?.data || [];

                const options = users
                    .filter(u => u.status === "active" && u.role === "MachineOperator")
                    .map(user => ({
                        value: user._id,
                        label: user.name,
                        storeIds: user.store?.map(s => s._id) || []
                    }));

                setOperatorOptions(options);
            } catch (err) {
                console.error(err);
            }
        };

        fetchUsers();
    }, []);

    const handleEditOperators = (item) => {
        setEditRowId(item._id);

        setSelectedOperators(
            item.operators?.map(op => ({
                value: op._id,
                label: op.name
            })) || []
        );
    };

    const handleSaveOperators = async (item) => {
        try {
            if (!selectedOperators.length) {
                return Swal.fire("Warning", "Please select at least one operator", "warning");
            }

            await AssestVechileServices.updateAssetVehicle(item._id, {
                operators: selectedOperators.map(op => op.value)
            });

            setData(prev =>
                prev.map(row =>
                    row._id === item._id
                        ? {
                            ...row,
                            operators: selectedOperators.map(op => ({
                                _id: op.value,
                                name: op.label
                            }))
                        }
                        : row
                )
            );

            setEditRowId(null);

            Swal.fire("Success", "Operators updated successfully", "success");

        } catch (err) {
            Swal.fire(
                "Error",
                err?.response?.data?.message || "Failed to update operators",
                "error"
            );
        }
    };


    const handleStatusToggle = async (item) => {
        try {
            const confirm = await Swal.fire({
                title: "Are you sure?",
                text: `Change status to ${item?.isActive ? "Inactive" : "Active"}?`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Yes, Update",
            });

            if (!confirm.isConfirmed) return;

            await AssestVechileServices.updateAssetVehicle(item._id, {
                isActive: !item.isActive
            });

            setData(prev =>
                prev.map(row =>
                    row._id === item._id
                        ? { ...row, isActive: !row.isActive }
                        : row
                )
            );

            Swal.fire("Success", "Status updated successfully", "success");

        } catch (err) {
            Swal.fire(
                "Error",
                err?.response?.data?.message || "Failed to update status",
                "error"
            );
        }
    };


    const CustomValueContainer = ({ children, ...props }) => {
        const values = props.getValue();

        if (!values || values.length === 0) {
            return (
                <components.ValueContainer {...props}>
                    {children}
                </components.ValueContainer>
            );
        }

        const first = values[0];
        const extraCount = values.length - 1;

        return (
            <components.ValueContainer {...props}>
                <div
                    onMouseEnter={(e) => {
                        props.selectProps.setHoverUsers(values);
                        props.selectProps.setShowHover(true);
                        props.selectProps.setHoverPosition({
                            x: e.clientX,
                            y: e.clientY
                        });
                    }}
                    onMouseLeave={() => {
                        props.selectProps.setShowHover(false);
                    }}
                >
                    {extraCount > 0 && (
                        <span style={{ color: "#007bff", fontWeight: "600" }}>
                            +{extraCount}
                        </span>
                    )}
                    <span className="ms-1">{first.label}</span>
                </div>
            </components.ValueContainer>
        );
    };

    const selectStyles = {
        control: (base) => ({
            ...base,
            minHeight: "42px",
            height: "42px",
            fontSize: "13px"
        }),
        valueContainer: (base) => ({
            ...base,
            height: "42px",
            padding: "0 8px"
        }),
        indicatorsContainer: (base) => ({
            ...base,
            height: "42px"
        }),
        menuPortal: (base) => ({
            ...base,
            zIndex: 9999
        })
    };

    const handleEditNumbers = (item) => {
        setEditNumberRowId(item._id);

        setEditValues({
            average: item.average ?? "",
            capacity: item.capacity ?? ""
        });
    };

    const handleSaveNumbers = async (item) => {
        try {
            if (!editValues.average || !editValues.capacity) {
                return Swal.fire("Warning", "Both fields are required", "warning");
            }

            await AssestVechileServices.updateAssetVehicle(item._id, {
                average: Number(editValues.average),
                capacity: Number(editValues.capacity)
            });

            setData(prev =>
                prev.map(row =>
                    row._id === item._id
                        ? {
                            ...row,
                            average: Number(editValues.average),
                            capacity: Number(editValues.capacity)
                        }
                        : row
                )
            );

            setEditNumberRowId(null);

            Swal.fire("Success", "Updated successfully", "success");

        } catch (err) {
            Swal.fire(
                "Error",
                err?.response?.data?.message || "Failed to update",
                "error"
            );
        }
    };

    const isStoreMismatch = (item) => {
        const assetStoreId = item?.asset?.store?._id;

        if (!assetStoreId || !item?.operators?.length) return false;

        return item.operators.some(op => {
            // find operator in options (we stored storeIds there)
            const user = operatorOptions.find(u => u.value === op._id);

            if (!user || !user.storeIds?.length) return true;

            return !user.storeIds.includes(assetStoreId);
        });
    };
    const mismatchedRows = filteredData
        .map((item, index) => ({
            index: index + 1,
            isMismatch: isStoreMismatch(item)
        }))
        .filter(row => row.isMismatch);

    return (
        <>

            <AssetVehicleModal
                show={showModal}
                handleClose={() => setShowModal(false)}
                onSuccess={fetchAssetVehicles}   // ✅ ADD THIS
            />

            <div className="row">
                <div className="col-xl-12">

                    {/* 🔍 Section 1 - Filter */}
                    <div className="filter cm-content-box box-primary">
                        <div className="content-title">
                            <div className="cpa">
                                <i className="fas fa-filter me-2"></i>Filter
                            </div>
                            <div className="tools">
                                <Link
                                    to={"#"}
                                    className={`SlideToolHeader ${open ? "collapse" : "expand"}`}
                                    onClick={() => setOpen(!open)}
                                >
                                    <i className="fas fa-angle-up"></i>
                                </Link>
                            </div>
                        </div>

                        <Collapse in={open}>
                            <div className="cm-content-body form excerpt">
                                <div className="card-body">
                                    <div className="row">

                                        {/* 🔍 Search */}
                                        <div className="col-xl-3 col-xxl-6">
                                            <input
                                                type="text"
                                                className="form-control mb-3"
                                                placeholder="Search Vehicle / Store / Equipment / Operator / Type"
                                                value={searchQuery}
                                                onChange={(e) => setSearchQuery(e.target.value)}
                                            />
                                        </div>

                                        {/* 📊 Rows */}
                                        <div className="col-xl-3 col-xxl-6">
                                            <Select
                                                placeholder="Rows"
                                                value={options.find(o => o.value === sort)}
                                                onChange={(opt) => setSort(opt.value)}
                                                options={options}
                                                isSearchable={false}
                                                className="custom-react-select"
                                            />
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </Collapse>
                    </div>


                    {/* 📋 Section 2 - Table */}
                    <div className="filter cm-content-box box-primary">
                        <div className="content-title d-flex justify-content-between align-items-center">

                            {/* Left Side */}
                            <div className="cpa">
                                <i className="fa fa-list me-2"></i>
                                Machine Allocation
                                <span className="badge bg-orange ms-2">{filteredData?.length}</span>
                            </div>

                            {/* Right Side */}
                            <div className="d-flex align-items-center">

                                {/* ➕ Add Icon */}
                                <i
                                    className="fa fa-plus text-success me-3"
                                    style={{ cursor: "pointer", fontSize: "16px" }}
                                    onClick={() => setShowModal(true)}
                                    title="Add Asset Vehicle"
                                > </i>New Machine Allocation

                                {/* Collapse Icon */}
                                <Link
                                    to={"#"}
                                    className={`SlideToolHeader ${open2 ? "collapse" : "expand"}`}
                                    onClick={() => setOpen2(!open2)}
                                >
                                    <i className="fas fa-angle-up"></i>
                                </Link>

                            </div>

                        </div>

                        <Collapse in={open2}>
                            <div className="cm-content-body form excerpt">
                                <div className="card-body">

                                    <div className="scrolltable">

                                        {mismatchedRows.length > 0 && (
                                            <div
                                                className="sticky-table-header"
                                            >
                                                <ul style={{ margin: 0, paddingLeft: "20px", color: "#b30000", fontWeight: "600" }}>
                                                    <li>
                                                        S.No{" "}
                                                        {mismatchedRows.map((r, i) => (
                                                            <span
                                                                key={i}
                                                                style={{
                                                                    cursor: "pointer",
                                                                    textDecoration: "underline",
                                                                    marginRight: "6px"
                                                                }}
                                                                onClick={() => {
                                                                    const el = document.getElementById(`row-${r.index}`);
                                                                    if (el) {
                                                                        el.scrollIntoView({
                                                                            behavior: "smooth",
                                                                            block: "center"
                                                                        });
                                                                    }
                                                                }}
                                                            >
                                                                {r.index}
                                                            </span>
                                                        ))}
                                                        have mismatch between asset store and operator store
                                                    </li>
                                                </ul>
                                            </div>
                                        )}

                                        <table
                                            className="table table-bordered table-striped"
                                        >
                                            <thead
                                                style={{
                                                    position: "sticky",
                                                    top: 0,
                                                    backgroundColor: "#fff", // White background
                                                    zIndex: 2,
                                                }}
                                            >
                                                <tr>
                                                    <th>S.No</th>
                                                    <th>Part No</th>
                                                    <th>Vehicle Name</th>
                                                    <th>Equipment No</th>
                                                    <th>Category</th>
                                                    <th>Store</th>

                                                    {/* ✅ NEW FIELDS */}
                                                    <th>Serial No</th>
                                                    <th>Model</th>
                                                    <th>Operators</th>
                                                    <th>Vendor</th>

                                                    <th>Average</th>
                                                    <th>Capacity</th>

                                                    <th>Type</th>
                                                    <th>Status</th>

                                                </tr>
                                            </thead>

                                            <tbody>
                                                {loading ? (
                                                    <tr>
                                                        <td colSpan="14" className="text-center">
                                                            Loading...
                                                        </td>
                                                    </tr>
                                                ) : filteredData.length > 0 ? (
                                                    filteredData.map((item, index) => (
                                                        <tr
                                                            key={index}
                                                            id={`row-${index + 1}`}   // ✅ ADD THIS
                                                            style={{
                                                                backgroundColor: isStoreMismatch(item) ? "#ffe5e5" : "",
                                                                color: isStoreMismatch(item) ? "#b30000" : "",
                                                                fontWeight: isStoreMismatch(item) ? "600" : "normal"
                                                            }}
                                                            title={
                                                                isStoreMismatch(item)
                                                                    ? "Operator store does not match asset store"
                                                                    : ""
                                                            }
                                                        >
                                                            <td>{index + 1}</td>

                                                            <td>{item?.asset?.masterItem?.partNo || "-"}</td>

                                                            <td className="scrollable-description">
                                                                {item?.asset?.masterItem?.description || "-"}
                                                            </td>
                                                            <td>{item?.asset?.equipmentNo || "-"}</td>

                                                            <td>{item?.asset?.masterItem?.category?.name || "-"}</td>

                                                            <td className="scrollable-description">
                                                                {item?.asset?.store?.name || "-"}
                                                            </td>

                                                            {/* ✅ NEW FIELDS */}
                                                            <td>{item?.asset?.serialNumber || "-"}</td>
                                                            <td>{item?.asset?.model || "-"}</td>
                                                            <td className="scrollable-description">
                                                                {editRowId === item._id ? (
                                                                    <div style={{ position: "relative" }}>
                                                                        <Select
                                                                            isMulti
                                                                            value={selectedOperators}
                                                                            onChange={(val) => setSelectedOperators(val || [])}
                                                                            options={operatorOptions.filter(opt =>
                                                                                opt.storeIds.includes(item?.asset?.store?._id)
                                                                            )}
                                                                            styles={selectStyles}
                                                                            menuPortalTarget={document.body}
                                                                            menuPosition="fixed"
                                                                            components={{ ValueContainer: CustomValueContainer }}

                                                                            setHoverUsers={setHoverUsers}
                                                                            setShowHover={setShowHover}
                                                                            setHoverPosition={setHoverPosition}
                                                                        />

                                                                        {/* ✅ SAVE + CANCEL */}
                                                                        <div className="mt-1">
                                                                            <button
                                                                                className="btn btn-success btn-xs me-1"
                                                                                onClick={() => handleSaveOperators(item)}
                                                                            >
                                                                                Save
                                                                            </button>

                                                                            <button
                                                                                className="btn btn-danger btn-xs"
                                                                                onClick={() => setEditRowId(null)}
                                                                            >
                                                                                Cancel
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                ) : item?.operators?.length ? (

                                                                    // ✅ CLICK TO EDIT
                                                                    <div
                                                                        onClick={() => handleEditOperators(item)}
                                                                        style={{ cursor: "pointer" }}
                                                                        title="Click to edit operators"
                                                                    >
                                                                        {item.operators.map((op, i) => (
                                                                            <div key={i}>{op.name}</div>
                                                                        ))}
                                                                    </div>

                                                                ) : (
                                                                    <span
                                                                        onClick={() => handleEditOperators(item)}
                                                                        style={{ cursor: "pointer", color: "#007bff" }}
                                                                    >
                                                                        + Add Operator
                                                                    </span>
                                                                )}
                                                            </td>
                                                            <td className="scrollable-description">{item?.asset?.vendor || "-"}</td>

                                                            <td>
                                                                {editNumberRowId === item._id ? (
                                                                    <div style={{ minWidth: "160px" }}>

                                                                        <input
                                                                            type="number"
                                                                            className="form-control form-control-sm mb-1"
                                                                            placeholder="Average"
                                                                            value={editValues.average}
                                                                            onChange={(e) =>
                                                                                setEditValues({ ...editValues, average: e.target.value })
                                                                            }
                                                                        />

                                                                        <input
                                                                            type="number"
                                                                            className="form-control form-control-sm mb-1"
                                                                            placeholder="Capacity"
                                                                            value={editValues.capacity}
                                                                            onChange={(e) =>
                                                                                setEditValues({ ...editValues, capacity: e.target.value })
                                                                            }
                                                                        />

                                                                        {/* ✅ SAVE + CANCEL */}
                                                                        <div className="d-flex gap-1">
                                                                            <button
                                                                                className="btn btn-success btn-xs"
                                                                                onClick={() => handleSaveNumbers(item)}
                                                                            >
                                                                                Save
                                                                            </button>

                                                                            <button
                                                                                className="btn btn-danger btn-xs"
                                                                                onClick={() => setEditNumberRowId(null)}
                                                                            >
                                                                                Cancel
                                                                            </button>
                                                                        </div>

                                                                    </div>
                                                                ) : (
                                                                    <span
                                                                        onClick={() => handleEditNumbers(item)}
                                                                        style={{ cursor: "pointer" }}
                                                                        title="Click to edit"
                                                                    >
                                                                        {item?.average ?? "-"}
                                                                    </span>
                                                                )}
                                                            </td>
                                                            <td>
                                                                {editNumberRowId === item._id ? (
                                                                    <span style={{ color: "#ccc" }}>—</span>   // ✅ disabled during edit
                                                                ) : (
                                                                    <span
                                                                        onClick={() => handleEditNumbers(item)}
                                                                        style={{ cursor: "pointer" }}
                                                                        title="Click to edit"
                                                                    >
                                                                        {item?.capacity ?? "-"}
                                                                    </span>
                                                                )}
                                                            </td>



                                                            <td>{item?.vehicleType || "NA"}</td>

                                                            <td>
                                                                <span
                                                                    onClick={() => handleStatusToggle(item)}
                                                                    style={{ cursor: "pointer" }}
                                                                >
                                                                    <i
                                                                        className={`fa ${item?.isActive ? "fa-circle text-success" : "fa-circle text-danger"
                                                                            }`}
                                                                    ></i>
                                                                </span>
                                                            </td>

                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="15" className="text-center">
                                                            No Data Found
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>

                                        </table>
                                        {showHover && (() => {
                                            const popupHeight = 140; // approx height (adjust if needed)
                                            const popupWidth = 220;

                                            const topPosition =
                                                hoverPosition.y > window.innerHeight / 2
                                                    ? hoverPosition.y - popupHeight   // ✅ show above
                                                    : hoverPosition.y + 10;           // ✅ show below

                                            const leftPosition = Math.min(
                                                hoverPosition.x + 10,
                                                window.innerWidth - popupWidth - 10 // ✅ prevent overflow right
                                            );

                                            return (
                                                <div
                                                    onMouseEnter={() => setShowHover(true)}
                                                    onMouseLeave={() => setShowHover(false)}
                                                    style={{
                                                        position: "fixed",
                                                        top: topPosition,
                                                        left: leftPosition,
                                                        background: "#fff",
                                                        border: "1px solid #ddd",
                                                        borderRadius: "6px",
                                                        padding: "10px",
                                                        boxShadow: "0 2px 10px rgba(0,0,0,0.15)",
                                                        zIndex: 9999,
                                                        minWidth: "200px",
                                                        maxHeight: "200px",          // ✅ scroll if many users
                                                        overflowY: "auto"
                                                    }}
                                                >
                                                    <div style={{ fontWeight: "600", marginBottom: "5px" }}>
                                                        Operators
                                                    </div>

                                                    {hoverUsers.map((user, i) => (
                                                        <div key={i}>{user.label}</div>
                                                    ))}
                                                </div>
                                            );
                                        })()}

                                    </div>

                                </div>
                            </div>
                        </Collapse>
                    </div>

                </div>
            </div>
        </>
    );
};

export default AssetVehicleList;